import { initExclusiveRadioSubmitGuard } from '../shared/exclusive-radio-submit-guard';

/**
 * Toggles TransactionId / FailureReason field visibility and submit-button
 * state in the resolve-donation modal based on the selected radio.
 */
export function initResolveDonationModal(): void {
    const modal = document.getElementById('resolveDonationModal');
    if (!modal) return;

    const completeFields = modal.querySelector<HTMLElement>('#completeFields');
    const failFields = modal.querySelector<HTMLElement>('#failFields');
    const transactionIdInput = modal.querySelector<HTMLInputElement>('#transactionId');
    const failureTextarea = modal.querySelector<HTMLTextAreaElement>('#failureReason');

    initExclusiveRadioSubmitGuard(modal, 'decisionComplete', 'decisionFail', 'resolveSubmitBtn', (isComplete, isFail) => {
        completeFields?.classList.toggle('d-none', !isComplete);
        failFields?.classList.toggle('d-none', !isFail);

        // TransactionId is only present when the donation has no existing txn ID.
        // When present, it is required for completion and must not block failure.
        if (transactionIdInput) {
            transactionIdInput.required = isComplete;
        }

        if (failureTextarea) {
            failureTextarea.required = isFail;
        }
    });
}
